import { render, staticRenderFns } from "./Dynamic_detail.vue?vue&type=template&id=24c045d5&scoped=true&"
import script from "./Dynamic_detail.vue?vue&type=script&lang=js&"
export * from "./Dynamic_detail.vue?vue&type=script&lang=js&"
import style0 from "./Dynamic_detail.vue?vue&type=style&index=0&id=24c045d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c045d5",
  null
  
)

export default component.exports